import createAxios from 'App/utils/createAxios';
import serializeJQLike from 'App/utils/serializeJQLike';

const { protocol, host, port } = window.location;
const therigyURL = `${protocol}//${host}${port ? `:${port}` : ''}`;

const phpRequest = createAxios({ baseURL: `${therigyURL}/app.api.php/api` }, { shouldShowToastFn: () => false });

const ajaxRequest = createAxios({ baseURL: `${therigyURL}/ajax` }, { shouldShowToastFn: () => false });

export function autocomplete(inputText) {
    if (!inputText) return;
    return phpRequest.get(`/user/physicians/like/${inputText}`);
}

export function getPhysician(physicianId) {
    return ajaxRequest.get(`/api.physician.php?id=${physicianId}`);
}

export function updatePhysician(params) {
    return ajaxRequest.post(`/api.physician.php`, null, {
        params: serializeJQLike(params),
    });
}
